import ReportSegmentV2 from './reportSegmentV2'
export default ReportSegmentV2
